var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.toastMsg.length
    ? _c("div", { staticClass: "toast-box" }, [
        _c("div", { staticClass: "toast" }, [
          _c(
            "p",
            _vm._l(_vm.toastMsg, function (msg, index) {
              return _c("span", { key: "msg" + index }, [
                _vm._v(" " + _vm._s(msg) + " "),
                _c("br"),
              ])
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }